import React, { Component } from 'react';
import { connect } from 'react-redux';
import { showBlocker, hideBlocker } from '../../actions/blocker';
import {
    saveMasterData,
    fetchMasterData,
    updateMasterData,
    deleteMasterData
} from '../../actions/master-data';
import DataTable from './data-table';
import Columns from './cols.json';

class MelCdl extends Component {
    constructor(props) {
        super(props);
        this.key = 'MELCDL';
        this.cols = Columns[this.key];
        this.state = {
            rows: [],
        };
        this.save = this.save.bind(this);
        this.update = this.update.bind(this);
        this.delete = this.delete.bind(this);
    }

    componentDidMount() {
        this.props.showBlocker();
        this.props.fetchMasterData(this.key, { sort: 'reg' })
            .done((data, textStatus, jqXHR) => this.setState({ rows: data }))
            .fail((jqXHR, status, error) => null)
            .always(this.props.hideBlocker);
    }

    save(data) {
        this.props.showBlocker();
        return this.props.saveMasterData(this.key, data)
            .done((data, textStatus, jqXHR) => {
                this.state.rows.splice(0, 0, data);
                this.setState({ rows: this.state.rows });
            })
            .fail((jqXHR, status, error) => null)
            .always(this.props.hideBlocker);
    }

    update(id, data) {
        this.props.showBlocker();
        return this.props.updateMasterData(this.key, id, data)
            .done((data, textStatus, jqXHR) => null)
            .fail((jqXHR, status, error) => null)
            .always(this.props.hideBlocker);
    }

    delete(id) {
        this.props.showBlocker();
        return this.props.deleteMasterData(this.key, id)
            .done((data, textStatus, jqXHR) => {
                this.state.rows.splice(this.state.rows.findIndex(row => row.id === id), 1);
                this.setState({ rows: this.state.rows });
            })
            .fail((jqXHR, status, error) => null)
            .always(this.props.hideBlocker);
    }

    render() {
        return <DataTable cols={this.cols}
            rows={this.state.rows}
            save={this.save}
            update={this.update}
            delete={this.delete} />
    }
}

const mapStateToProps = state => ({});

const mapActionsToProps = {
    showBlocker, hideBlocker,
    saveMasterData, fetchMasterData, updateMasterData, deleteMasterData,
};

export default connect(mapStateToProps, mapActionsToProps)(MelCdl);
